import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/analytics/')({
  component: AnalyticsIndex,
});

function AnalyticsIndex() {
  return <Navigate to="/analytics/personnel-performance" replace />;
}
